<a [href]="pdfLink" [class]="pdfLinkClass" [title]="pdfLinkTitle" rel="nofollow noopener" target="_blank">
    <ng-content></ng-content>
</a>
